<template>
    <div class="linechart">
        <div style="height:317px;padding-top:10px;width:100%" id="line_charts"></div>
    </div>
</template>
<script>
    import echarts from 'echarts/lib/echarts';
    // 引入提示框和标题组件
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/title';
    import 'echarts/lib/component/legend';
    // import 'echarts/lib/component/toolbox';
    import 'echarts/lib/component/axis';
    import 'echarts/lib/component/axisPointer';
    import 'echarts/lib/chart/line';
    import $ from 'jquery';
    export default {
        name:'lineChart',
        data(){
            return {
                dataList:[]
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
                this.getChartList();
            },
            getChartList(){
                let _this = this;
                this.getRequest("/wemediaTotal/getWemediaIncomeBrokenLine",{dayNum:7}).then(res => {
                    console.log(res)
                    // _this.lineCharts(res.legend,res.series)
                });
            },
            // 折线图
            lineCharts(times,incomeData,datatime){
                var lineChart = echarts.init(document.getElementById('line_charts'))
                var optionLine = {
                    title: {
                        text: '最近'+ 7 + '日收益（元）'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'none',
                            animation: false,    
                        },
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data:times,
                        axisTick:{
                            show:false
                        },
                        axisLine:{
                            show:false,
                        },
                        axisLabel:{
                            formatter:function(value,index){
                                return value
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        scale: true,
                        name: '',
                        min: 0,
                        boundaryGap: false,
                        gridIndex:0,
                        axisTick:{
                            show:false
                        },
                        axisLine:{
                            show:false,
                        }
                    },
                    series: [
                        {
                            name:'',
                            type:'line',
                            // smooth:true,  //这个是把线变成曲线
                            data:incomeData,
                            itemStyle:{
                                normal:{
                                    color:'#95E799',  
                                    lineStyle:{
                                        color:'#95E799'
                                    }
                                }
                            },
                            yAxisindex:0,
                        }
                    ]
                }
                // 使用刚指定的配置项和数据显示图表。
                lineChart.setOption(optionLine)
                // window.onresize = function () {
                //     myBottomChart.resize();
                // }
                $(window).resize(function(){
                    lineChart.resize();
                });
            }
        }
    }
</script> 
